import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import { RootState } from "../reducers";
import { useSelector } from "react-redux";

const PageHowPay = () => {
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  return (
    <Container>
       {textPages?.textHowtopay && parse(textPages.textHowtopay)}
    </Container>
  );
}
export default PageHowPay;